import { useCallback, useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import {
  LinearLoadingOverlay,
  Table,
  Pagination,
} from '../../components/table/Table';
import * as service from '../../services/admin-service';
import { useAlerts } from '../../hooks/use-alerts';
import { useGrowers } from '../../hooks/use-growers';

export function Downloads() {
  const fetching = useRef(false);
  const { selectedId: growerId } = useGrowers();
  const [isWorking, setWorking] = useState();
  const [downloads, setDownloads] = useState();
  const [totalDownloads, setTotalUploads] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 1000,
  });
  const { showError } = useAlerts();
  const apiRef = useGridApiRef();

  const fetchData = useCallback(() => {
    if (fetching.current) return;

    fetching.current = true;
    setWorking(true);

    service
      .getDownloads(growerId, paginationModel.page, paginationModel.pageSize)
      .then((response) => {
        setDownloads(response.data);
        setTotalUploads(response.total);
      })
      .catch(showError)
      .finally(() => {
        fetching.current = false;
        setWorking(false);
      });
  }, [growerId, paginationModel.page, paginationModel.pageSize, showError]);

  useEffect(() => {
    fetchData();
  }, [fetchData, paginationModel.page]);

  return (
    <>
      <Box
        sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}
      >
        <Table
          hideFooter={false}
          loading={isWorking || !downloads}
          columns={buildColumns()}
          rows={downloads || []}
          rowCount={totalDownloads}
          pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[100]}
          slots={{
            pagination: Pagination,
            loadingOverlay: LinearLoadingOverlay,
          }}
          apiRef={apiRef}
        />
      </Box>
    </>
  );

  function buildColumns() {
    return [
      {
        field: 'downloadedAt',
        headerName: 'Downloaded At',
        flex: 1.5,
        type: 'dateTime',
        valueFormatter: ({ value }) =>
          new Date(value).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
          }),
      },
      {
        field: 'downloadedBy',
        headerName: 'Downloaded By',
        flex: 0.75,
      },
      {
        field: 'operationName',
        headerName: 'Operation',
        flex: 1,
      },
      {
        field: 'rx',
        headerName: 'Rx',
        flex: 0.75,
      },
      {
        field: 'type',
        headerName: 'Type',
        flex: 0.75,
      },
      {
        field: 'fieldName',
        headerName: 'Field Name',
        flex: 1,
      },
      {
        field: 'acres',
        headerName: 'Acres',
        type: 'number',
        flex: 0.75,
        minWidth: 75,
        valueFormatter: ({ value }) =>
          Number(value)
            ? Number(value).toLocaleString('en-US', {
                maximumFractionDigits: 2,
              })
            : '',
      },
    ];
  }
}
